import { useCallback } from 'react';
import { useSetPollWinnerMutation } from '@bo-services/pollsApi';

export const useSetPollWinner = () => {
  const [
    createPollWinner,
    { isLoading, error: createPollWinnerError, isSuccess }
  ] = useSetPollWinnerMutation();

  const handleSetPollWinner = useCallback(
    async (id: string) => {
      try {
        return await createPollWinner(id);
      } catch (error) {
        return error;
      }
    },
    [createPollWinner]
  );

  return {
    isLoading,
    createPollWinnerError,
    handleSetPollWinner,
    isSuccess
  };
};
